export default "Would you like to see foot traffic on a weekly basis or a monthly basis?";